module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Stop_16"],"rect":[{"$":{"x":"4","y":"4","width":"8","height":"8","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Stop_16.svg
// module id = e+QZ
// module chunks = 1